<template>
  <v-col
    :cols="showListObjectInfoVertically ? 12 : 6"
  >
    <v-container class="pa-0 list-features">
      <v-row
        style="white-space: nowrap; text-overflow: ellipsis;"
        no-gutters
      >
        <v-col cols="12">
          <v-icon small style="width: 24px;margin-right: 4px;">
            fa-home
          </v-icon>
          {{ objectTypeComputed }}
        </v-col>
        <v-col cols="12">
          <v-icon small style="width: 24px;margin-right: 4px;">
            fa-user
          </v-icon>
          {{ capitalize($i18n.t('max')) }} {{ object.maxPeople }} {{ $i18n.t('inimest') }}
        </v-col>
        <v-col cols="12">
          <v-icon small style="width: 24px;margin-right: 4px;">
            fa-bed
          </v-icon>
          {{ object.bedrooms }} {{ object.bedrooms > 1 ? $i18n.t('magamistoaga') : $i18n.t('magamistuba') }}
        </v-col>
        <v-col cols="12">
          <v-icon small style="width: 24px;margin-right: 4px;">
            fa-bath
          </v-icon>
          {{ object.bathrooms }} {{ object.bathrooms > 1 ? $i18n.t('vannitoaga') : $i18n.t('vannituba') }}
        </v-col>
        <v-col cols="12" v-if="swimmingPoolFeature">
          <v-icon small style="width: 24px;margin-right: 4px;">
            {{ swimmingPoolFeature && swimmingPoolFeature.icon }}
          </v-icon>
          {{ swimmingPoolFeature && swimmingPoolFeature['name_' + lang] }}
        </v-col>
        <v-col cols="12" v-else>
          <v-icon small style="width: 24px;margin-right: 4px;">
            {{ parkingFeature && parkingFeature.icon }}
          </v-icon>
          {{ parkingFeature && parkingFeature['name_' + lang] }}
        </v-col>
        <v-col cols="12">
          <v-icon
            v-for="(icon, iconIndex) in featuresInListIcons"
            :key="iconIndex"
            small
            style="padding: 3px 8px 2px 2px;"
            v-tooltip.bottom-start="$vuetify.breakpoint.smAndUp ? icon && icon['name_' + lang] : ''"
          >
            {{ icon.icon }}
          </v-icon>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import sharedComputed from '@/methods/sharedComputed'
import state from '@/store/state'
import { createHelpers } from 'vuex-map-fields'
import sharedMethods from '@/methods/sharedMethods'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ListObjectFeatures',

  props: {
    object: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,

    objectTypeComputed () {
      return this.capitalize(this.object.exactType && this.object.exactType['typeName_' + this.lang] ||
        this.object.type['typeName_' + this.lang])
    },

    featuresInListIcons () {
      const objectListFeatures = []
      Object.keys(this.featuresList).forEach(key => {
        const feature = this.featuresList[key]
        const isParkingFeature = feature?.code?.includes('parking')
        if (feature && (!isParkingFeature || this.swimmingPoolFeature) &&
          feature.showIconInList && this.object.features &&
          this.object.features[key] && this.object.features[key].checked
        ) {
          objectListFeatures.push(feature)
        }
      })
      return objectListFeatures
    },

    swimmingPoolFeature () {
      const swimmingFeatures = Object.keys(this.featuresList).filter(id => {
        return this.featuresList[id] && this.featuresList[id].code && this.featuresList[id].code.includes('wimming') && this.object.features &&
          this.object.features[id] && this.object.features[id].checked
      }).map(id => {
        return this.featuresList[id]
      })
      return swimmingFeatures[0]
    },

    parkingFeature () {
      const parkingFeatures = Object.keys(this.featuresList).filter(id => {
        return this.featuresList[id] && this.featuresList[id].code && this.featuresList[id].code.includes('parking') && this.object.features &&
          this.object.features[id] && this.object.features[id].checked
      }).map(id => {
        return this.featuresList[id]
      })
      return parkingFeatures[0]
    },
  },

  methods: {
    ...sharedMethods,
  },
}
</script>
